<template>
  <div class="baseIndexMd"  @click.stop>
    <!-- 弹出遮罩层 -->
    <div class="basePop" v-if="phoneBtn || codeBtn " @touchstart="onBasePop">

    </div>
    <!-- 二维码公众号 -->
    <div class="baseTop">
        <div class="baseTopItem" v-for="item in media" :key="item.id">
            <span class="baseTopItemImg">
                <img class="image" :src="item.images"  alt="">
            </span>
            <p class="baseTopItemText">{{item.name}}</p>
        </div>
    </div>
    <!-- 联系我们 -->
    <div class="baseBottom">
        <div class="baseBottomItem" v-for="bitem in baseBottomList" :key="bitem.id">
          <img class="baseBottomItemImgMd" :src="bitem.images"  alt="">
          <span class="baseBottomItemText">{{bitem.name}}</span>
        </div>
    </div>
    <!-- 底部快捷导航 -->
    <div class="baseNav">
      <div class="baseNavItem" @click="openPhone">
        <p class="baseNavItemImg"><img src="./img/baseNav1.png" alt=""></p>
        <p class="baseNavItemText">电话沟通</p>
        <!-- 弹出框 -->
          <div class="phone" v-show="phoneBtn" @click="callPhone">
          <p class="phoneItem"><i> <img src="./img/phone1.png" alt=""> </i> 400-991-9533</p>
          <!-- <p class="phoneItem"> <i> <img src="./img/phone2.png" alt=""> </i>工作时间</p>
          <p class="phoneItem" >9:00/12:00 13:30/17:30</p> -->
        </div>
      </div>
      <div class="baseNavItem" @click="openCode">
        <p class="baseNavItemImg"><img src="./img/baseNav2.png" alt=""></p>
        <p class="baseNavItemText">扫码咨询</p>
              <!-- 二维码 -->
            <div class="searchBCenimage" v-show="codeBtn">
              <p>扫一扫，关注我们</p>
              <div class="searchImg">
                <img  src="./img/weixingongzhonghao.png" alt="" />
              </div>
              <p>郑州时空微信公众号</p>
          </div>
      </div>
      <div class="baseNavItem" @click="goSolve">
        <p class="baseNavItemImg"><img src="./img/baseNav3.png" alt=""></p>
        <p class="baseNavItemText">获取方案</p>
      </div>
      <div class="baseNavItem" @click="goHome">
        <p class="baseNavItemImg"><img src="./img/baseNav4.png" alt=""></p>
        <p class="baseNavItemText">返回首页</p>
      </div>
    </div>
   </div>
</template>

<script>
export default {
  name: 'baseIndex',
  data () {
    return {
      media: [
        {
          id: '1',
          name: '官方微信公众号',
          images: require('@/views/Base/img/weixingongzhonghao.png')
        },
        {
          id: '2',
          name: '官方抖音号',
          images: require('@/views/Base/img/douyinhao.png')
        }
      ],
      baseBottomList: [
        {
          id: '1',
          name: '官方服务热线：400-991-9533',
          images: require('@/views/Base/img/dianhua.png')
        },
        // {
        //   id: '2',
        //   name: '公司邮箱：zsh424@126.com',
        //   images: require('@/views/Base/img/youxiang.png')
        // },
        {
          id: '3',
          name: '地址：郑州市中科智谷12栋楼7层',
          images: require('@/views/Base/img/dizhi.png')
        }
      ],
      phoneBtn: false, // 电话沟通显示
      codeBtn: false // 二维码显示

    }
  },
  mounted () {
    document.body.addEventListener('click', () => {
      this.phoneBtn = false
      this.codeBtn = false
    }, false)
  },

  methods: {
    openPhone () {
      this.phoneBtn = !this.phoneBtn
      this.codeBtn = false
    },
    openCode () {
      this.codeBtn = !this.codeBtn
      this.phoneBtn = false
    },
    goSolve () {
      this.$router.push('/solve')
      this.phoneBtn = false
      this.codeBtn = false
    },
    goHome () {
      this.$router.push('/')
      this.phoneBtn = false
      this.codeBtn = false
    },
    // 点击拨号
    callPhone () {
      // console.log('11111')
      this.phoneBtn = false
      window.location.href = 'tel://' + '400-991-9533'
    },
    onBasePop () {
      this.phoneBtn = false
      this.codeBtn = false
    }
  }
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
// 遮罩层
.basePop{
  width:100vw;
  height: 100vh;
  position: fixed;
  bottom:114px/$md;
  z-index: 980;
}
// 主体
  .baseIndexMd{
    height: 705px/$md ;
    padding-top: 50px/$md;
    box-sizing: border-box;
    background: #F2F4F8;
    .baseTop {
        display: flex;
        justify-content: space-between;
        width: 480px/$md;
        margin-left: 135px/$md;
        .baseTopItem{
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: center;
            .baseTopItemImg{
                width:190px/$md;
                height: 190px/$md;
                margin-bottom: 14px/$md;
            }
            .baseTopItemText{
                margin: 0;
               font-size: 26px/$md;
               font-weight: 500;
               color: #333333;
            }
        }
    }
    // 底部地址
    .baseBottom{
        display: flex;
        justify-content: space-around;
        // align-items: center;
        flex-direction: column;
        width: 558px/$md;
        height: 197px/$md;
        background: #FFFFFF;
        border-radius: 14px/$md;
        margin-left: 96px/$md;
        margin-top: 36px/$md;
        // margin-top: 36px/$md;
        // margin-left: 96px/$md;
        // padding: 30px/$md 66px/$md;
        // box-sizing: border-box;
        // 每个item
        .baseBottomItem{
          display: flex;
          align-items: center;
            height: 35px/$md;
            // padding-top: 25px/$md;
            padding-left: 66px/$md;
            .baseBottomItemImgMd{
                width: 28px/$md;
                height: 28px/$md;
                margin-right: 10px/$md;
            }
            .baseBottomItemText{
              font-size: 26px/$md;
              font-weight: 400;
              color: #333333;
            }

        }
    }
  }
  .image{
    width: 100%;
    height: 100%;
  }
  // 底部快捷导航
  .baseNav{
    position:fixed;
    bottom: 0;
    height: 114px/$md;
    width: 750px/$md;
    display: flex;
    justify-content: space-around;
    z-index: 990;
      background: #FFFFFF;
      // border-top:1px solid #666 ;
      box-shadow: 0 0 1px/$md #666 ;
    .baseNavItem{
      width: 100px/$md;
      font-size: 18px/$md;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666666;
      p{
        margin: 0;
      }
      .baseNavItemImg{
        width: 40px/$md;
        height: 40px/$md;
        margin-bottom: 20px/$md;
        img{
          width: 100%;
        }
      }
    }
    // 弹出框联系
    .phone{
      position: fixed;
      bottom: 120px/$md;
      left: 5px/$md;
      width: 240px/$md;
      height: 158px/$md;
      background-color: #fff;
      box-shadow: 0 4px/$md 8px/$md 0 rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      box-sizing: border-box;
      align-items: center;
      .phoneItem{
        font-size: 18px/$md;
       display: flex;
        align-items: center;
        justify-content: center;
       text-align:center;
        i{
         width: 18px/$md;
         height: 18px/$md;
         img{
           width: 100%;
         }
        }
      }
    }
    // 弹出二维码
  .searchBCenimage{
  width: 280px/$md;
  height: 247px/$md;
  background-color: #fff;
  position: fixed;
  left: 155px/$md;
  bottom: 120px/$md;
  box-shadow: 0 4px/$md 8px/$md 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // padding: 26px/$md;
    box-sizing: border-box;
    align-items: center;
    .searchImg{
      width: 145px/$md;
      height: 145px/$md;
      // width: 145px/$md*$sun;
      // height: 145px/$md*$sun;
      img{
        width: 100%;
      }
    }
    p{
      font-size: 16px/$md;
    }

}
  }
</style>
